import { render, staticRenderFns } from "./InspectionCreateCardAsset.vue?vue&type=template&id=f492c428&scoped=true&"
import script from "./InspectionCreateCardAsset.vue?vue&type=script&lang=ts&"
export * from "./InspectionCreateCardAsset.vue?vue&type=script&lang=ts&"
import style0 from "./InspectionCreateCardAsset.vue?vue&type=style&index=0&id=f492c428&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f492c428",
  null
  
)

export default component.exports